// extracted by mini-css-extract-plugin
export var alertIcon = "_m4-0";